'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnyCustomChatName = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('./keyPaths');

var _getCustomChatName = require('./getCustomChatName');

var _getFallback = require('./getFallback');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAnyCustomChatName = exports.getAnyCustomChatName = function getAnyCustomChatName(chatHeadingConfig) {
  return (0, _getIn2.default)(_keyPaths.CUSTOM_CHAT_NAME, chatHeadingConfig) || (0, _getCustomChatName.getCustomChatName)((0, _getFallback.getFallback)(chatHeadingConfig));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/chat-heading-config/operators/getAnyCustomChatName.js
// module id = 513
// module chunks = 2 3